module.exports = __webpack_public_path__ + "img/paradigm.41e077c1.svg";